// initial state
import axios from "axios";


const state = () => ({
    countries: [], // Created via admin
    costing_types: [], // Gross or Net
    suppliers: [], // Organisation
    service_types: [], // List populated via Admin
    amount_types: [] // Percentage or Fixed Amount
})


// getters
const getters = {}

// actions
const actions = {
    async getSuppliers ({ commit }) {
        axios.get(route('frontend.organisations.suppliers.list')).then(result => {
            commit('setSuppliers', result.data)
        });
    },
    async getCountries ({ commit }) {
        axios.get(route('frontend.organisations.clients.list')).then(result => {
            commit('setCountries', result.data)
        });
    },
    async getServiceTypes ({ commit }) {
        axios.get(route('frontend.organisations.clients.list')).then(result => {
            commit('setServiceTypes', result.data)
        });
    },
    async getCostingTypes ({ commit }) {
        axios.get(route('frontend.organisations.clients.list')).then(result => {
            commit('setCostingTypes', result.data)
        });
    },
    async getTypes ({ commit }) {
        axios.get(route('frontend.organisations.clients.list')).then(result => {
            commit('setAmountTypes', result.data)
        });
    },
    async getAll ({ commit }, params) {
        axios.get(route('frontend.project.quote.service.populate', [params.project_id, params.quote_id])).then(result => {
            commit('setAll', result.data)
        });
    }
}

// mutations
const mutations = {
    setSuppliers (state, suppliers) {
        state.suppliers = suppliers
    },
    setCountries (state, countries) {
        state.countries = countries
    },
    setServiceTypes (state, service_types) {
        state.service_types = service_types
    },
    setCostingTypes (state, costing_types) {
        state.costing_types = costing_types
    },
    setAmountTypes (state, amount_types) {
        state.amount_types = amount_types
    },
    setAll (state, all) {
        state.suppliers = all.suppliers
        state.countries = all.countries
        state.service_types = all.service_types
        state.amount_types = all.amount_types
        state.costing_types = all.costing_types
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

